import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'

export default class HomeSliderComponent {
    constructor() {
        HomeSliderComponent.complexSlider()
        HomeSliderComponent.simpleSlider()
        HomeSliderComponent.fullSlider()
    }

    static async complexSlider() {
        await Swiper.create('#complex-slider', {
            slidesPerView: 1,
            spaceBetween: 20,
            allowTouchMove: false,
            loop: true,
            lazyPreloadPrevNext: 10,
            loopAdditionalSlides: 10,
            pagination: {
                el: '.swiper-pagination',
                type: 'progressbar',
            },
            navigation: {
                nextEl: '.strate-complex-slider__footer__arrows__item--next',
                prevEl: '.strate-complex-slider__footer__arrows__item--prev',
            },
            breakpoints: {
                1453: {
                    spaceBetween: 40,
                },
            },
        })
    }

    static async simpleSlider() {
        await Swiper.create('.strate-simple-slider__slider', {
            slidesPerView: 1.2,
            spaceBetween: 10,
            pagination: {
                el: '.swiper-pagination',
                type: 'progressbar',
            },
            navigation: {
                nextEl: '.strate-simple-slider__footer__arrows__item--next',
                prevEl: '.strate-simple-slider__footer__arrows__item--prev',
            },
            breakpoints: {
                650: {
                    slidesPerView: 2.5,
                    allowTouchMove: true,
                    spaceBetween: 20,
                },
                1000: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                    allowTouchMove: false,
                },
                1453: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                    allowTouchMove: false,
                },
            },
        })
    }

    static async fullSlider() {
        await Swiper.create('#full-slider', {
            slidesPerView: 1.2,
            spaceBetween: 10,
            allowTouchMove: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'progressbar',
            },
            navigation: {
                nextEl: '.strate-simple-slider__footer__arrows__item--next',
                prevEl: '.strate-simple-slider__footer__arrows__item--prev',
            },
            breakpoints: {
                650: {
                    slidesPerView: 1.2,
                    spaceBetween: 20,
                    allowTouchMove: true,
                },
                1000: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    allowTouchMove: false,
                },
                1453: {
                    slidesPerView: 1,
                    spaceBetween: 40,
                    allowTouchMove: false,
                },
            },
        })
    }
}
